import { createAction, props } from '@ngrx/store';
import { AddedPaymentMethod, PaymentMethod } from '../dto/payment-method.dto';

export const loadPaymentMethods = createAction('[PaymentMethod] Load PaymentMethods', props<{ request: string }>());

export const loadPaymentMethodsSuccess = createAction(
  '[PaymentMethod] Load PaymentMethods Success',
  props<{ response: AddedPaymentMethod[] }>()
);

export const loadPaymentMethodsFailure = createAction('[PaymentMethod] Load PaymentMethods Failure', props<{ error: Error | any }>());
